import styled from 'styled-components';

import { mediaSize } from '../../../../styles';
import { DropdownWithDots } from '../../../../components/popovers';


export const User = styled.div`
  position: relative;
  width: 267px;
  height: 86px;
  border: 1px solid ${props => props.theme.colors.borderLightSilver};
  display: flex;
  align-items: center;
  padding: 16px;
  flex-shrink: 0;
  background-color: ${props => !props.isActivated && props.theme.colors.borderLightSilver};
  margin-bottom: 11px;
  
  &:nth-child(2n + 1) {
    margin-right: 11px;
  }
  @media (max-width: ${mediaSize.tablet}) {
    margin-right: 11px;
  }
`;

export const UserLeft = styled.div`
  margin-right: 16px;
  flex-shrink: 0;
`;

export const UserRight = styled.div`
  width: 100%;
  margin-top: 2px;
`;

export const UserImage = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
`;

export const UserTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1;
`;

export const UserName = styled.div`
  margin-right: 7px;
  font-size: 15px;
  color: ${props => props.theme.colors.fontDark};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: ${({ isWithRole }) => isWithRole ? 120 : 145}px;
`;

export const UserRole = styled.div`
  background: ${props => props.theme.colors.green};
  font-size: 8px;
  height: 12px;
  line-height: 1.4;
  padding: 1px 9px;
  color: ${props => props.theme.colors.white};
  letter-spacing: 0.6px;
  border-radius: 10px;
`;

export const UserEmail = styled.a`
  color: ${props => props.theme.colors.fontSilverPrimary};
  font-weight: 300;
  font-size: 13px;
  display: inline-block;
  line-height: 1;
  word-break: break-all;
  margin-top: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 170px;
  
  &:hover,
  &:focus {
    text-decoration: underline;
    color: ${props => props.theme.colors.fontSilverPrimary};
  }
`;

export const WaitingForResponse = styled.div`
  font-size: 9px;
  margin-top: 2px;
  color: ${props => props.theme.colors.fontTangerine};
`;

export const Deleted = styled(WaitingForResponse)`
  color: ${props => props.theme.colors.red};
`;

export const DropdownS = styled(DropdownWithDots)`
  position: absolute;
  top: 0;
  right: 0;
  height: 30px;
`;

export const SimpleButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/modals/manage-users-modal/list-users/user-list-item/styled-components.js